import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/listagem`

    return {
        index() {
            return repository.get(`${baseUrl}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        veiculos(queryParms = {}) {
            return repository.get(`${baseUrl}/veiculo?${urlUtil.serialize(queryParms)}`)
        },
        municipios(queryParms = {}) {
            return repository.get(`${baseUrl}/municipio?${urlUtil.serialize(queryParms)}`)
        },
        bairros(queryParms = {}) {
            return repository.get(`${baseUrl}/bairro?${urlUtil.serialize(queryParms)}`)
        },
        jornadas(queryParms = {}) {
            return repository.get(`${baseUrl}/jornada?${urlUtil.serialize(queryParms)}`)
        },
        search(queryParms = {}) {
            return repository.get(`${baseUrl}/search?${urlUtil.serialize(queryParms)}`)
        },
        motorista(queryParms = {}) {
            return repository.get(`${baseUrl}/motorista?${urlUtil.serialize(queryParms)}`)
        }
    }
}